import actions from './OrderSearch.actions.js';
import getters from './OrderSearch.getters.js';
import mutations from './OrderSearch.mutations.js';
import state from './OrderSearch.state.js';

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};